<template>
  <div v-if="currentStep === 1" class="food-categories-component mx-auto">
    <v-btn-toggle v-model="localCurrentCollection" dense group class="mx-auto">
      <v-slide-group show-arrows>
        <v-slide-item v-for="(collection, i) in collections" :key="i">
          <v-btn
            :value="collection.id"
            class="button font-weight-medium text-normalize"
            depressed
          >
            {{ collection.name }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-btn-toggle>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'FoodCategories',
    computed: {
      ...mapState({
        currentCategory: (state) => state.newOrder.currentCategory,
        currentCollection: (state) => state.newOrder.currentCollectionId,
        menuItemsList: (state) => state.newOrder.menuItemsList,
        collections: (state) => state.newOrder.collectionsList,
        currentStep: (state) => state.newOrder.currentStep,
      }),
      localCurrentCollection: {
        get () {
          return this.currentCollection
        },
        set (value) {
          if (value !== undefined) {
            this.$store.commit('newOrder/setMenuItemsLoading', true)
            this.$store
              .dispatch('collections/fetchSingleCollections', value)
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    'newOrder/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit('newOrder/setMenuItemsLoading', false)
              })
          } else {
            this.$store.commit('newOrder/setMenuItemsLoading', true)
            const id = this.currentCategory
            this.$store
              .dispatch('categories/fetchFilialMenuSingleCategories', { id })
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    'newOrder/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit('newOrder/setMenuItemsLoading', false)
              })
          }
          this.$store.commit('newOrder/setCurrentCollectionId', value)
        },
      },
    },
  }
</script>

<style lang="less" scoped>
.food-categories-component {
  margin-bottom: 37px;
  max-width: 100%;
  overflow: hidden;
  .button {
    border-radius: 10px;
    font-size: 16px;
    line-height: 21px;
    background-color: @color-secondary !important;
    height: 64px;
    padding: 0 23px;
    margin-right: 21px;
    &:before {
      content: none;
    }
    &.v-item--active {
      background-color: @color-primary !important;
      color: #ffffff;
    }
  }
}
</style>
